export default {};

//# sourceMappingURL=defaultClient.js.map